import { IconOwnProps, Tooltip } from '@mui/material'
import { AlertRule } from '../types/Alerts'
import { AlertRuleDataGridRow } from './AlertRuleDataGrid'
import { AlertRuleName } from '../enums'
import {
  Air,
  Battery1Bar,
  Bolt,
  HeatPump,
  SignalCellular0Bar,
  SignalCellular1Bar,
  SignalCellularOff,
  Thermostat,
  WaterDrop
} from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

export interface AlertRuleIcon extends IconOwnProps {
  alertRule: AlertRule | AlertRuleDataGridRow | AlertRuleName
}

export default function AlertRuleIcon({ alertRule, ...props }: AlertRuleIcon) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('alert')

  /**
   * The alert rule name.
   */
  const alertRuleName = typeof alertRule === 'string' ? alertRule : alertRule.name

  /**
   * Indicates if the thermostat icon should be used.
   */
  const isThermostat =
    alertRuleName === AlertRuleName.HIGH_TEMPERATURE ||
    alertRuleName === AlertRuleName.LOW_TEMPERATURE ||
    alertRuleName === AlertRuleName.TARGET_TEMPERATURE_NOT_REACHED ||
    alertRuleName === AlertRuleName.RAPID_TEMPERATURE_DROP ||
    alertRuleName === AlertRuleName.RAPID_TEMPERATURE_RISE

  /**
   * Indicates if the water drop icon should be used.
   */
  const isWaterDrop =
    alertRuleName === AlertRuleName.HIGH_HUMIDITY ||
    alertRuleName === AlertRuleName.LOW_HUMIDITY ||
    alertRuleName === AlertRuleName.DEW_POINT ||
    alertRuleName === AlertRuleName.CONDENSTATION_RISK_INTAKE ||
    alertRuleName === AlertRuleName.CONDENSATION_RISK_EXHAUST

  /**
   * Indicates if the air icon should be used.
   */
  const isAir =
    alertRuleName === AlertRuleName.HIGH_PRESSURE ||
    alertRuleName === AlertRuleName.LOW_PRESSURE ||
    alertRuleName === AlertRuleName.EXHAUST_AIR_TOO_COLD ||
    alertRuleName === AlertRuleName.EXHAUST_AIR_TOO_HOT

  /**
   * Indicates if the battery icon should be used.
   */
  const isBattery = alertRuleName === AlertRuleName.LOW_BATTERY

  /**
   * Indicates if the heat pump icon should be used.
   */
  const isHeatPump =
    alertRuleName === AlertRuleName.HEATING_WHILE_VALVE_CLOSED ||
    alertRuleName === AlertRuleName.NO_HEATING

  /**
   * Indicates if the alert rule is for signal.
   */
  const isSignal =
    alertRuleName === AlertRuleName.LOW_SIGNAL || alertRuleName == AlertRuleName.WEAK_SIGNAL

  const isSignalOff = alertRuleName === AlertRuleName.DEVICE_OFFLINE

  return (
    <>
      {isThermostat ? (
        <Thermostat {...props} />
      ) : isWaterDrop ? (
        <WaterDrop {...props} />
      ) : isAir ? (
        <Air {...props} />
      ) : isHeatPump ? (
        <HeatPump {...props} />
      ) : isBattery ? (
        <Battery1Bar {...props} />
      ) : isSignal ? (
        <SignalCellular1Bar {...props} />
      ) : isSignalOff ? (
        <SignalCellularOff {...props} />
      ) : (
        <Bolt {...props} />
      )}
    </>
  )
}
